/* eslint-disable */
import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalController, NavParams } from '@ionic/angular';
import { CONSTANTS } from 'src/app/services/config.service';
import { GisService } from 'src/app/services/gis.service';
import { LoggerService } from 'src/app/services/logger.service';
import { MapsService } from 'src/app/services/maps.service';
import { PointsHelperService } from 'src/app/services/points-helper.service';
import { MSRemoteLoggerCategory } from 'src/app/adapters/remote-logger/utils/remote-logger.utils';

@Component({
  selector: 'app-survey-map',
  templateUrl: './survey-map-browser.page.html',
  styleUrls: ['./survey-map.page.scss']
})
export class SurveyMapBrowserPage implements OnInit {
  @ViewChild('map') mapElement: ElementRef;
  data: any = {};
  points: any = [];
  mapLoaded: boolean;
  mapTab = 'overview';
  START_STOP_ZOOM = 7;

  constructor(
    private navParams: NavParams,
    public modalCtrl: ModalController,
    private logger: LoggerService,
    private gis: GisService,
    private maps: MapsService,
    private pointsHelper: PointsHelperService
  ) {}

  setBounds(center, radiusMeters) {
    const latDelta = this.gis.getLatDegrees(radiusMeters);
    const north = { lat: center.lat + latDelta, lng: center.lng };
    const south = { lat: center.lat - latDelta, lng: center.lng };
    this.maps.setMapBounds([north, center, south]);
  }

  /************************************************************************************************************************************************************************
   * SET MAP VIEW
   ***********************************************************************************************************************************************************************/

  showStart() {
    if (!this.data.isLongDistance) {
      this.maps.showPoint(this.points[0]);
    } else {
      this.setBounds(this.points[0], CONSTANTS.tripRecording.GEOFENCE_RADIUS * 1.5);
    }
  }

  showStop() {
    if (!this.data.isLongDistance) {
      this.maps.showPoint(this.points[this.points.length - 1]);
    } else {
      this.setBounds(this.points[this.points.length - 1], CONSTANTS.tripRecording.DWELL_METERS * 1.5);
    }
  }

  showOverview() {
    if (!this.data.isLongDistance) {
      this.maps.setMapType('MAP_TYPE_NORMAL');
    }
    this.maps.showOverview(null, this.data.survey.addedTripType === 'LOOP');
  }

  /************************************************************************************************************************************************************************
   * NAVIGATE
   ***********************************************************************************************************************************************************************/

  dismiss() {
    this.maps.removeMap().then(() => {
      this.modalCtrl.dismiss();
    });
  }

  init() {
    this.logger.log('ionViewDidLoad MapSurveyPage', MSRemoteLoggerCategory.SURVEY_MAP_BROWSER_PAGE);
    this.data = this.navParams.data;
    this.pointsHelper
      .getPoints(this.data.earlier, this.data.survey, this.data.isLongDistance, false)
      .then((res) => {
        this.points = res.locations;
        return this.maps.init(this.mapElement.nativeElement, this.points[0], this.points);
        // return this.maps.init(this.mapElement.nativeElement, this.pleaseConnect.nativeElement, this.points[this.points.length-1], this.points);
      })
      .then(() => {
        if (this.data.isLongDistance) {
          return this.maps.addCirclesAndMarkers(this.points, this.data.survey);
        } else {
          return this.maps.addMarkersAndPath(this.points, this.data.survey);
        }
      })
      .then(() => {
        this.showOverview();

        this.mapLoaded = true;
        if (this.data.isLongDistance) {
          this.mapTab = 'stop';
          this.showStop();
        } else {
          this.mapTab = 'overview';
          // this.showOverview();
        }
      })
      .catch((err) => {
        this.logger.log('****MAP ERROR****', MSRemoteLoggerCategory.SURVEY_MAP_BROWSER_PAGE, err);
      });
  }

  ionViewDidEnter() {
    this.init();
  }

  ngOnInit() {}

  async ngOnDestroy() {
    await this.maps.removeMap(true);
  }
}
